import { ChevronLeft, ChevronRight, CalendarDays, RefreshCw } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Calendar } from "../../../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover";
import { isoDate, parseIso, prettyDate, athensToday } from "../../../booking/utils";

const shift = (iso, n) => {
  const d = parseIso(iso);
  d.setDate(d.getDate() + n);
  return isoDate(d);
};

export const DayToolbar = ({ date, setDate, stats, refreshing, onRefresh }) => (
  <div className="flex flex-wrap items-center gap-3">
    <div className="flex flex-wrap items-center gap-1">
      <Button variant="outline" size="icon" onClick={() => setDate(shift(date, -1))} data-testid="cal-prev-day"><ChevronLeft size={16} /></Button>
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="sm:min-w-[230px] justify-start" data-testid="cal-date-picker">
            <CalendarDays size={15} className="mr-2" /> {prettyDate(date)}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" weekStartsOn={1} selected={parseIso(date)} onSelect={(d) => d && setDate(isoDate(d))} />
        </PopoverContent>
      </Popover>
      <Button variant="outline" size="icon" onClick={() => setDate(shift(date, 1))} data-testid="cal-next-day"><ChevronRight size={16} /></Button>
      <Button variant="ghost" onClick={() => setDate(athensToday())} data-testid="cal-today">Today</Button>
    </div>
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm sm:ml-auto" data-testid="cal-stats">
      {stats && (
        <>
          <span><b>{stats.bookings}</b> bookings</span>
          <span><b>{stats.pax}</b> guests</span>
          <span><b>{stats.arrived}</b> arrived</span>
          <span className="text-stone-500">{stats.free} spots free</span>
        </>
      )}
      <button onClick={onRefresh} aria-label="Refresh" data-testid="cal-refresh" className="text-stone-500 hover:text-stone-900">
        <RefreshCw size={15} className={refreshing ? "animate-spin" : ""} />
      </button>
    </div>
  </div>
);
